
export const feedbackViews = self => ({
    get customerName() {
        return self.user?.firstName
    },
    get reviewText() {
        return self.text
      }
})